import { useRef, useState, ChangeEvent } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DriveFolderUploadRoundedIcon from "@mui/icons-material/DriveFolderUploadRounded";

interface ImagePickerProps {
  imagePreview: string | null;
  onImageSelect: (file: File) => void;
}

const ImagePicker: React.FC<ImagePickerProps> = ({
  imagePreview,
  onImageSelect,
}) => {
  const [hovered, setHovered] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onImageSelect(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      style={{
        position: "relative",
        width: "auto",
        height: "auto",
        cursor: "pointer",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleClick}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        style={{ display: "none" }}
      />

      <div
        style={{
          width: "280px",
          height: "280px",
          borderRadius: "50%",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #707070",
          position: "relative",
        }}
      >
        {imagePreview ? (
          <img
            src={imagePreview}
            alt="Prévia"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <DriveFolderUploadRoundedIcon
              style={{ fontSize: 100, color: "#bbb" }}
            />
            <span
              style={{
                border: "1px solid #0A0C33",
                padding: "8px",
                borderRadius: "5px",
              }}
            >
              Add Foto
            </span>
          </div>
        )}

        {hovered && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              borderRadius: "50%",
            }}
          >
            <CameraAltIcon style={{ fontSize: 24 }} />
            <span>{imagePreview ? "Trocar Foto" : "Incluir Foto"}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImagePicker;
